import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from "@material-ui/core/styles";
import CloseButtonDialog from './CloseButtonDialog';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import { Typography } from '@material-ui/core';
import axios from 'axios';
import _ from 'underscore';
import { RecibidosContext } from 'App/Recibidos/store';
import { LayoutContext } from 'App/Layout/store';
import { DigitoVerificador, separadorMiles } from "App/Helpers/Genericos";
import TextField from '@material-ui/core/TextField';
import { Imprimir, DescargarXML } from 'App/components/TablaDTE';
import IconButton from '@material-ui/core/IconButton';
import PrintIcon from "@material-ui/icons/Print";
import Code from "@material-ui/icons/Code";
import QRCode from "@material-ui/icons/CalendarViewDay";
import Tooltip from '@material-ui/core/Tooltip';

import moment from 'moment';

const styles = theme => ({
    timeline: {
        listStyleType: "none",
        position: "relative",
        '&::before': {
            content: "' '",
            background: "#d4d9df",
            display: "inline-block",
            position: "absolute",
            left: "29px",
            width: "2px",
            height: "100%",
            zIndex: 400
        }
    },
    timelineList: {
        margin: "20px 0",
        paddingLeft: "20px",
        '&::before': {
            content: "' '",
            background: "white",
            display: "inline-block",
            position: "absolute",
            borderRadius: "50%",
            border: "3px solid #2196F3",
            left: "20px",
            width: "20px",
            height: "20px",
            zIndex: 400,
        }
    },
    active: {
        '&::before': {
            border: "3px solid #4caf50",
        }
    },
});

var datosError = [
    { Codigo: "REC", Nombre: "Recibido por el SII" },
    { Codigo: "RSC", Nombre: "Rechazado por Error en Schema" },
    { Codigo: "SOK", Nombre: "Schema Validado" },
    { Codigo: "CRT", Nombre: "Caratula OK" },
    { Codigo: "RFR", Nombre: "Rechazado por Parametros de Entrada Incompletos" },
    { Codigo: "FOK", Nombre: "Error: Retorno Datos" },
    { Codigo: "Enviado", Nombre: "Enviado al SII" },
    { Codigo: "PRD", Nombre: "Error: Retorno Datos" },
    { Codigo: "RCT", Nombre: "Rechazado por Error en Caratula" },
    { Codigo: "EPR", Nombre: "Procesado por el SII" }
]

function DetallesDTE(props) {
    const { classes } = props;
    const recibidosContext = useContext(RecibidosContext);
    const layoutContext = useContext(LayoutContext);
    const [detalles, setDetalles] = useState({});


    useEffect(() => {
        if (props.abrir && props.DTE[0] != detalles.Id) {
            axios.get("/api/DTE/Id/" + props.DTE[0] + "/detalles")
                .then(detalles => {
                    setDetalles({ ...detalles, Id: props.DTE[0] })
                }).catch((e) => {
                    alert("Ocurrió un error al rescatar los detalles del DTE")
                    props.cerrar();
                    console.log(e)
                })
        }
    }, [props.abrir])

    var content =
        _.isEmpty(detalles) ? null : <Grid container>
            <Grid xs={12}>
                <Typography align="right">
                    <Tooltip title={"Descargar Timbre"}>
                        <IconButton onClick={() => DescargarXML(detalles.Id, "TED")}>
                            <QRCode />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Descargar Documento"}>
                        <IconButton onClick={() => DescargarXML(detalles.Id, "DTE")}>
                            <Code />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Imprimir"}>
                        <IconButton onClick={() => Imprimir(null, [{ id_dte: detalles.Id }])}>
                            <PrintIcon />
                        </IconButton>
                    </Tooltip>
                </Typography>
            </Grid>
            <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Razón Social Emisor" InputProps={{ readOnly: true }} variant="filled" value={detalles.Emisor.RazonSocial} fullWidth /></Typography></Grid>
            <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Rut Emisor" InputProps={{ readOnly: true }} variant="filled" value={separadorMiles(detalles.Emisor.Rut) + "-" + DigitoVerificador(detalles.Emisor.Rut)} fullWidth /></Typography></Grid>
            <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Razón Social Receptor" InputProps={{ readOnly: true }} variant="filled" value={detalles.Receptor.RazonSocial} fullWidth /></Typography></Grid>
            <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Rut Receptor" InputProps={{ readOnly: true }} variant="filled" value={separadorMiles(detalles.Receptor.Rut) + "-" + DigitoVerificador(detalles.Receptor.Rut)} fullWidth /></Typography></Grid>
            {detalles.Usuario && <Grid xs={4}><Typography style={{ margin: 8 }} ><TextField label="Creado por" InputProps={{ readOnly: true }} variant="filled" value={detalles.Usuario} fullWidth /></Typography></Grid>}
            <Grid xs={detalles.Usuario ? 4 : 6}><Typography style={{ margin: 8 }} ><TextField label="Fecha Creación" InputProps={{ readOnly: true }} variant="filled" value={moment(detalles.FechaCreacion).format("LL")} fullWidth /></Typography></Grid>
            <Grid xs={detalles.Usuario ? 4 : 6}><Typography style={{ margin: 8 }} ><TextField label="Fecha Emisión" InputProps={{ readOnly: true }} variant="filled" value={moment(detalles.FechaEmision).format("LL")} fullWidth /></Typography></Grid>
            <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Estado" InputProps={{ readOnly: true }} variant="filled" value={detalles.Estado} fullWidth /></Typography></Grid>
            <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="TrackId SII" InputProps={{ readOnly: true }} variant="filled" value={detalles.Trackid || ""} fullWidth /></Typography></Grid>
            {detalles.Errores && detalles.Errores.length ? detalles.Errores.map((e, i) => <>
                <Grid xs={12}><Typography style={{ margin: 8 }} ><TextField label="Mensaje SII" InputProps={{ readOnly: true }} variant="filled" value={e.Codigo + " - " + e.Descripcion} fullWidth /></Typography></Grid>
            </>) : null}
            <Divider variant="middle" />
            <Grid xs={12}>
                <Grid xs={12}><Typography variant="h6" style={{ margin: 8 }}><b>Eventos Asyntec DTE</b></Typography></Grid>
                <Grid xs={12}><Typography style={{ margin: 8 }}>
                    <ul className={classes.timeline}>
                        {detalles.Estados/* .reverse() */.map((e, i) =>
                            <li alignItems="flex-start" className={`${classes.timelineList} ${i == detalles.Estados.length - 1 ? classes.active : ""}`}>
                                <ListItemText
                                    primary={(datosError.find(k => k.Codigo == e.Nombre) || e).Nombre}
                                    secondary={moment(e.Fecha).format("LLL")} />
                            </li>
                        )
                        }
                    </ul>
                </Typography></Grid>
            </Grid>
            <Grid xs={12}>
                <Grid xs={12}><Typography variant="h6" style={{ margin: 8 }}><b>Eventos Comerciales</b></Typography></Grid>
                <Grid xs={12}><Typography style={{ margin: 8 }}>
                    <ul className={classes.timeline}>
                        {_.sortBy(detalles.Eventos, o => o.Fecha)/* .reverse() */.map((e, i) =>
                            <li alignItems="flex-start" className={`${classes.timelineList} ${i == detalles.Eventos.length - 1 ? classes.active : ""}`}>
                                <ListItemText
                                    primary={e.Glosa}
                                    secondary={`${moment(e.Fecha).format("LLL")}${(e.Rut?` (${e.Rut}-${e.Dv})`:"")}`} />
                            </li>
                        )
                        }
                    </ul>
                </Typography></Grid>
                {
                    layoutContext.state.datosEmpresa && layoutContext.state.datosEmpresa.Rut != detalles.Emisor.Rut
                    && !_.any(detalles.Eventos, o => (o.Glosa.toLowerCase() || "").includes("contado")) && ["Factura Electrónica", "Factura no Afecta o Exenta Electrónica", "Liquidación-Factura Electrónica"].indexOf(detalles.Tipo) >= 0 && moment(detalles.FechaCreacion).add(8, 'days').diff(moment().startOf('day')) > 0 && <Grid xs={12}>
                        <Button variant="contained" size="small" onClick={() => {
                            recibidosContext.dispatch({
                                type: "setDocumentosRespuesta", data: [{
                                    id_dte: detalles.Id,
                                    folio: detalles.Folio,
                                    rut: detalles.Emisor.Rut,
                                    razon_social: detalles.Emisor.RazonSocial,
                                    tipo_dte: detalles.Tipo,
                                    fecha_emision: moment(detalles.FechaEmision, ["DD-MM-YYYY"]).toDate()
                                }]
                            })
                            recibidosContext.dispatch({ type: "toggleRespuestaComercial" });
                        }
                        } color="primary">
                            Agregar Respuesta Comercial
                        </Button>
                    </Grid>}
            </Grid>

        </Grid>;

    const footer = (
        <DialogActions>
            <Button onClick={() => props.cerrar()} color="secondary" autoFocus>
                Cerrar
            </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={props.abrir} onClose={() => props.cerrar()} closeButton title={"Detalles " + (_.isEmpty(detalles) ? "" : (detalles.Tipo + " N°: " + detalles.Folio))} content={content} footer={footer} size="md" />
        </div>
    );
}

export default withStyles(styles)(React.memo(DetallesDTE));